import Vue from 'vue';
import VueI18n from 'vue-i18n';
// mui
import zhLocale from '@midea/mui/src/locale/lang/zh-CN';
import enLocale from '@midea/mui/src/locale/lang/en-US';
// 自定义 ---!!!!!! 已迁移至翻译平台
// import indexLang from './modules/index/index';
// import componentsLang from './components/index';
// import gscLang from './gsc/index';
// import oldLang from './old/index';

import { setCookie } from '@/utils/index';
// 翻译平台导出的语言包, 需要更新则在翻译平台上新增后再重新导出，而不是手动改代码
import zh from './gscPackages/zh.json';
import en from './gscPackages/en.json';
import ja from './gscPackages/ja.json';
import pt from './gscPackages/pt.json';
import ru from './gscPackages/ru.json';
import th from './gscPackages/th.json';
import vi from './gscPackages/vi.json';
import ar from './gscPackages/ar.json';

export default {
    initLanguage(userLang) {
    // 用户设置的语言>浏览器的语言>默认语言
        const navLang = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
        const localLang = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'ja-JP' || navLang === 'th' || navLang === 'vi' || navLang === 'ar') ? navLang : false;
        const lang = userLang || localLang || 'zh-CN';
        Vue.use(VueI18n);
        setCookie('iflow_locale', lang, { domain: '.midea.com' });
        return new VueI18n({
            locale: lang,
            messages: {
                'zh-CN': Object.assign({}, zh, zhLocale),
                'en-US': Object.assign({}, en, enLocale),
                'ja-JP': Object.assign({}, ja, enLocale),
                zh: Object.assign({}, zh, zhLocale),
                en: Object.assign({}, en, enLocale),
                ja: Object.assign({}, ja, enLocale),
                pt: Object.assign({}, pt, enLocale),
                ru: Object.assign({}, ru, enLocale),
                th: Object.assign({}, th, enLocale),
                vi: Object.assign({}, vi, enLocale),
                ar: Object.assign({}, ar, enLocale),
            },
        });
    },
};
